"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/testimonialSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useRef } from "react";

type TestimonialSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Lauren Parker" | "Michael Adams" | "Andrew Cooper" | "David Turner" | "Natalie Carter" */
    h30Text: ReactNode;
    /** Detected variants: "Seattle, WA" | "Chicago, IL" | "Nashville, TN" | "Orlando, FL" | "Denver, CO" */
    p0Text: ReactNode;
    /** Detected variants: "Lauren Parker" | "Michael Adams" | "Andrew Cooper" | "David Turner" | "Natalie Carter" */
    alt: string;
    /** Detected variants: "/Templates/Doccure/img/reviews/author-10.jpg" | "/Templates/Doccure/img/reviews/author-11.jpg" | "/Templates/Doccure/img/reviews/author-12.jpg" | "/Templates/Doccure/img/reviews/author-13.jpg" | "/Templates/Doccure/img/reviews/author-14.jpg" */
    src: string;
    /** Detected variants: "Dr. Kim's artistry with veneers has revitalized my smile. His meticulous approach ensured natural-looking results, and I frequently receive compliments, boosting my self-esteem." | "The wisdom tooth extraction was handled with care and compassion. The swift procedure and supportive staff made recovery seamless, allowing me to focus on healing and wellness." | "The aligner treatment was a game-changer for my smile. Tailored to my needs, the plan was effective and the results surpassed my expectations, enhancing my confidence and well-being." | "Dr. Lopez's expertise in fillings was evident. She guided me through each step, ensuring comfort in a welcoming clinic, which greatly contributed to my overall health and peace of mind." | "Dr. Hernandez provided a thorough dental cleaning, emphasizing holistic oral health. Her clear guidance on preventive care has significantly enhanced my daily hygiene, contributing to my journey." */
    p0P0Text: ReactNode;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "testimonial-item-seventeen" */
    div0ClassName?: string;
    /** Detected variants: "testimonial-user" */
    div0ClassName2?: string;
    /** Detected variants: "author-info" */
    div0ClassName3?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "mb-0" */
    p0ClassName?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName2?: string;
    ratingItems?: TestimonialSectionFasFaStarFilledsItem[];
};

type TestimonialSectionFasFaStarFilledsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fas fa-star filled" */
    className?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    centerMode: true,
    responsive: [
        {
            breakpoint: 1400,
            settings: { slidesToShow: 3, slidesToScroll: 1 },
        },
        {
            breakpoint: 1200,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
            breakpoint: 992,
            settings: { slidesToShow: 2, slidesToScroll: 1 },
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1, slidesToScroll: 1, variableWidth: false, centerMode: false },
        },
    ],
};

export type HomeSeventeenTestimonialSectionGeneratedProps = {
    divDiv0Div0Div0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Real Transformations, Real People" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Hear from clients who've experienced life-changing results" */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionSlider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    testimonialSectionSlides: TestimonialSectionSlidesItem[];
    testimonialSectionSlidesItemWrapper?: (item: TestimonialSectionSlidesItem, content: ReactNode) => ReactNode;
    testimonialSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidesImageVisible?: boolean;
    testimonialSectionSlidesImageRenderer?: (item: TestimonialSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidesH3Visible?: boolean;
    testimonialSectionSlidesH3Renderer?: (item: TestimonialSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    testimonialSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TestimonialSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    testimonialSectionSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: TestimonialSectionSlidesItem) => Partial<ComponentProps<"h3">>);
    testimonialSectionFasFaStarFilledsItemWrapper?: (item: TestimonialSectionFasFaStarFilledsItem, content: ReactNode) => ReactNode;
    testimonialSectionFasFaStarFilledsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeSeventeenTestimonialSectionGenerated: FC<HomeSeventeenTestimonialSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Real Transformations, Real People",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "Hear from clients who've experienced life-changing results",
    divDiv0Div0Div0H30H3Props,
    divDiv0Div0ImageWithBasePath0ImageProps,
    sectionSlider0SliderProps,
    testimonialSectionSlides,
    testimonialSectionSlidesItemWrapper,
    testimonialSectionSlidesRenderer,
    testimonialSectionSlidesImageVisible,
    testimonialSectionSlidesImageRenderer,
    testimonialSectionSlidesH3Visible,
    testimonialSectionSlidesH3Renderer,
    testimonialSectionSlidesImageProps,
    testimonialSectionSlidesH3Props,
    testimonialSectionFasFaStarFilledsItemWrapper,
    testimonialSectionFasFaStarFilledsRenderer,
}) => {
    const sliderRef = useRef<Slider | null>(null);
    return (
        <section className="testimonial-section-seventeen section">
            <div className="container">
                <div className="section-header section-header-seventeen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-gradient" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
            </div>
            <Slider ref={sliderRef} {...settings} className="testimonial-slider-seventeen" {...(sectionSlider0SliderProps ?? {})}>
                {renderCollectionNode(
                    testimonialSectionSlides,
                    (item: TestimonialSectionSlidesItem) => (
                        <div className={item.className ?? "slide-item"} key={item.key}>
                            <div className={item.div0ClassName ?? "testimonial-item-seventeen"}>
                                <div className={item.div0ClassName2 ?? "testimonial-user"}>
                                    {renderItemNode(testimonialSectionSlidesImageVisible, testimonialSectionSlidesImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof testimonialSectionSlidesImageProps === "function" ? testimonialSectionSlidesImageProps(item) : (testimonialSectionSlidesImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                    <div className={item.div0ClassName3 ?? "author-info"}>
                                        {renderItemNode(testimonialSectionSlidesH3Visible, testimonialSectionSlidesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof testimonialSectionSlidesH3Props === "function" ? testimonialSectionSlidesH3Props(item) : (testimonialSectionSlidesH3Props ?? {}))} {...(typeof divDiv0Div0Div0H30H3Props === "function" ? divDiv0Div0Div0H30H3Props(item) : (divDiv0Div0Div0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "mb-0"}>{item.p0Text}</p>
                                    </div>
                                </div>
                                <p className={item.p0ClassName2 ?? "description"}>{item.p0P0Text}</p>
                                <div className="rating">
                                    {renderCollectionNode(
                                        item.ratingItems ?? [],
                                        (item: TestimonialSectionFasFaStarFilledsItem) => (
                                            <i className={item.className ?? "fas fa-star filled"} key={item.key}></i>
                                        ),
                                        testimonialSectionFasFaStarFilledsItemWrapper,
                                        testimonialSectionFasFaStarFilledsRenderer
                                    )}
                                </div>
                            </div>
                        </div>
                    ),
                    testimonialSectionSlidesItemWrapper,
                    testimonialSectionSlidesRenderer
                )}
            </Slider>
        </section>
    );
};

export default HomeSeventeenTestimonialSectionGenerated;
